import { createSlice } from '@reduxjs/toolkit'
import { 
  forgotPassword, 
  changePassword, 
  resetPassword, 
  adminLogin, 
  verifyMfa,
  updateProfile, 
  getProfile, 
  activateUser, 
  getHome,
  addSectionToHome,
  deleteSectionFromHome,
  deleteFileFromSection,
  reorderSections,adminLogout
 } from '../actions/adminAction'

export const admin = createSlice({
  name: 'admin',
  initialState: {
    isAdminLoggedIn: false,
    adminDetail: null,
    error: null,
    isLoader: false,
    isRecordUpdated: false,
    invalidJwtToken: false,
    sections:[],
    isSectionInserted:false,
    currentStep: 0,
    isHomeUpdated:false,
    home:[],
    isChanges:false,
  },
  reducers: {
    checkAdmin: (state, {payload}) => {
      state.isAdminLoggedIn = payload ? true: false
      state.adminDetail= JSON.parse(payload);
    },
    adminManage: state => {
      state.isAdminLoggedIn = true
    },
    updateChanges: (state, {payload}) =>{
      state.isChanges = payload;
    },
    adminReset: state => {
        // state.isAdminLoggedIn = false;
        // state.adminDetail = null;
        state.error = null;
        state.isLoader = false;
        state.isRecordUpdated = false;
      },
      resetHome: state => {
        state.home= [];
        state.isRecordAdded = false;
        state.isRecordLoaded = false;
        state.isRecordAdded = false;
      }, 
      resetPopup: state => {
        state.isLoader= false;
        state.isRecordUpdated= false;
        state.error=null;
      },
    resetError: state => {
        state.error = null;
        state.isLoader = false;
      },
      resetHomeUpdated: state => {
        state.isHomeUpdated = false;
      },
      resetSection: state => {
        state.isSectionInserted=false
      }, 
      resetStep: state => {
        state.currentStep = 0;
        state.error = null;
      },
      setCurrentStep: (state, {payload})=> {
        state.currentStep = payload;
        state.error = null;
      },
      updateSection:(state, {payload}) => {
        state.sections=[...state.sections,payload]   
        state.isSectionInserted = true;
      },
      removeSection:(state, {payload}) => {  
        state.sections=state.sections.filter((_, payload) => payload !== 0)
        state.isSectionInserted = true; 
      },
      adminLogoutSuccess: (state) => {
        state.isAdminLoggedIn = false;
        state.adminDetail = null;
        state.error = null;
        state.isLoader = false;
        state.isRecordUpdated = false;
      },
      adminLogoutFailure: (state, { payload }) => {
        state.error = payload;
        state.isLoader = false;
      },
  },
  extraReducers: {
    [adminLogin.pending]: (state, action) => {
      state.error = null;
      state.isAdminLoggedIn= false;
     
    },
    //actions can be destructure like this action = {payload}
    [adminLogin.fulfilled]: (state, {payload}) => {
      const responseData = payload?.data || {};
      const token = responseData?.token;
      const mfaRequired = !!responseData?.mfaRequired;
      const user = responseData?.user || responseData;

      state.error = null;
      state.adminDetail = user || null;

      // Login is complete only when backend says MFA is not required and token exists.
      state.isAdminLoggedIn = !mfaRequired && !!token;
    },
    [adminLogin.rejected]: (state, {payload}) => {
      state.adminDetail= null;
      state.isAdminLoggedIn= false;
      state.error= payload;
    },
    [verifyMfa.pending]: (state) => {
      state.error = null;
      state.isAdminLoggedIn = false;
    },
    [verifyMfa.fulfilled]: (state, {payload}) => {
      const responseData = payload?.data || {};
      const token = responseData?.token;
      const mfaRequired = !!responseData?.mfaRequired;
      const user = responseData?.user || responseData;

      state.error = null;
      state.adminDetail = user || null;
      state.isAdminLoggedIn = !mfaRequired && !!token;
    },
    [verifyMfa.rejected]: (state, {payload}) => {
      state.adminDetail = null;
      state.isAdminLoggedIn = false;
      state.error = payload;
    },
    [adminLogout.fulfilled]: (state, {payload}) => {
      state.isAdminLoggedIn = false;
      state.adminDetail = null;
      state.error = null;
      state.isLoader = false;
      state.isRecordUpdated = false;
    },
    [adminLogout.rejected]: (state, {payload}) => {
      state.error = payload;
      state.isLoader = false;
    },
   
    [updateProfile.pending]: (state, action) => {
      state.error = null;
      state.isLoader = true;
    },
    [updateProfile.fulfilled]: (state, {payload}) => {
      state.error = null;
      state.isRecordUpdated = true;
      state.isLoader = false;
    },
    [updateProfile.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
    },
    [getProfile.pending]: (state, action) => {
      state.error = null;
      state.isLoader = true;
    },
    [getProfile.fulfilled]: (state, {payload}) => {
      // state.adminDetail= payload?.data;
      state.error = null;
      state.isLoader = false;
      state.isAdminLoggedIn= true;
      state.adminDetail= payload.data;
    },
    [getProfile.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isAdminLoggedIn= false;
      state.isLoader = false;
    },
    [getHome.pending]: (state, action) => {
      state.error = null;
      state.isLoader = true;
      state.isHomeUpdated=false;
    },
    [getHome.fulfilled]: (state, {payload}) => {
      state.error = null;
      state.isLoader = false;
      state.home= payload.data.sections;
      state.isHomeUpdated=true;
    },
    [getHome.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
      state.isHomeUpdated=false;
    },
    [addSectionToHome.pending]: (state, action) => {
      state.error = null;
      state.isLoader = true;
      state.isHomeUpdated=false;
    },
    [addSectionToHome.fulfilled]: (state, {payload}) => {
      state.error = null;
      state.isLoader = false;
      state.home= payload.data.sections;
      state.isHomeUpdated=true;
    },
    [addSectionToHome.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
      state.isHomeUpdated=false;
    },
    [deleteSectionFromHome.pending]: (state, action) => {
      state.error = null;
      state.isLoader = true;
      state.isHomeUpdated=false;
    },
    [deleteSectionFromHome.fulfilled]: (state, {payload}) => {
      state.error = null;
      state.isLoader = false;
      state.home= payload.data.sections;
      state.isHomeUpdated=true;
    },
    [deleteSectionFromHome.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
      state.isHomeUpdated=false;
    },
    [deleteFileFromSection.pending]: (state, action) => {
      state.error = null;
      state.isLoader = true;
      state.isHomeUpdated=false;
    },
    [deleteFileFromSection.fulfilled]: (state, {payload}) => {
      state.error = null;
      state.isLoader = false;
      state.home= payload.data.sections;
      state.isHomeUpdated=true;
    },
    [deleteFileFromSection.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
      state.isHomeUpdated=false;
    },
    [forgotPassword.pending]: (state, action) => {
      state.error = null;
      state.isLoader = true;
    },
    [forgotPassword.fulfilled]: (state, action) => {
      state.error = null;
      state.isLoader = false;
      state.isRecordUpdated = true;
    },
    [forgotPassword.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
    },
    [changePassword.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [changePassword.fulfilled]: (state, {payload}) => {
      state.error = null;
      state.isLoader = false;
      state.isRecordUpdated = true;
    },
    [changePassword.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
    },
    [resetPassword.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [resetPassword.fulfilled]: (state, {payload}) => {
      state.error = null;
      state.isLoader = false;
      state.isRecordUpdated = true;
    },
    [resetPassword.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
    },
    [activateUser.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [activateUser.fulfilled]: (state, {payload}) => {
      state.error = null;
      state.isLoader = false;
      state.isRecordUpdated = true;
    },
    [activateUser.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
    },

    [reorderSections.pending]: (state, action) => {
      state.error = null;
      state.isLoader = true;
      state.isHomeUpdated=false;
    },
    [reorderSections.fulfilled]: (state, {payload}) => {
      state.error = null;
      state.isLoader = false;
      state.home= payload.data.sections;
      state.isHomeUpdated=true;
    },
    [reorderSections.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
      state.isHomeUpdated=false;
    },
   
  }
})

// Action creators are generated for each case reducer function
export const { adminManage,resetHomeUpdated,updateChanges, adminReset, adminLogoutSuccess,adminLogoutFailure, checkAdmin, resetError, resetStep,resetSection, setCurrentStep, resetPopup, resetHome, updateSection, removeSection,  } = admin.actions

export default admin.reducer